const NS = 'NotepadBlock';
const CLS = 'notepadBlock';

import Popper from 'popper.js';

export class NotepadBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

        this.$form = $(`.notepadBlock-notepad-form-container`);
        this.saveAPI = this.$form.data('saveApi');
		this.downloadAPI = this.$form.data('downloadApi');
		this.viewCourseNotesAPI = this.$form.data('viewNotesApi');
        this.saveButton = this.$form.data('saveButton');
        this.viewButton = this.$form.data('viewButton');

        const notepadEditor = $('#notepadEditor');
        const tooltip = $('#notepadTooltip');
        let sel = window.getSelection();
        let copiedText = '';
        let popperInstance;
        let selCurrent = '-';
        const virtualElement = {
            getBoundingClientRect: generateGetBoundingClientRect()
        };

        // TinyMCE
        if(typeof tinymce === 'object') {
            // eslint-disable-next-line no-undef
            tinymce.init({
                selector: `#notepadEditor`,
                plugins: 'lists',
                content_css: '/Static/wlc/assets/css/tinymce.css',
                menubar: false,
                statusbar: false,
                paste_as_text: true,
                height: '100%',
				toolbar: 'bold italic bullist | customDownloadButton customViewCourseNotesButton customSaveButton',
                setup: (editor) => {
                    editor.ui.registry.addButton('customDownloadButton', {
                        icon: 'fullscreen',
                        tooltip: 'Download',
                        classes: 'myclass',
                        onAction: () => {
                            // Notepad share/email button
                            window.open(this.downloadAPI);
                            return false;
                        }
					});
					editor.ui.registry.addButton('customViewCourseNotesButton', {
						text: this.viewButton,
						tooltip: 'View All',
						onAction: () => {
							// Notepad share/email button
							window.open(this.viewCourseNotesAPI);
							return false;
						}
					});
                    editor.ui.registry.addButton('customSaveButton', {
                        text: this.saveButton,
                        tooltip: 'Save',
                        onAction: () => {
                            // Saving functionality (to be replaced with AJAX / server side)
                            var array = this.$form.serializeArray()
							var formData = {};
							
                            $.map(array, function (n, i) {
                                formData[n['name']] = n['value'];
                            });
            
							formData['notepadText'] = editor.getContent();
                            // Removes empty field values
                            _.forOwn(formData, (value, key) => {
                                if(_.isNil(value) || value.trim() === '') {
                                    delete formData[key];
                                }
                            });

                            var json_text = JSON.stringify(formData);

                            let request = new Request(this.saveAPI, {
                                method: 'POST',
                                body: json_text,
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            });
            
                            // submit form data using fetch api
                            fetch(request)
                                .then((response) => {
                                    if(response.status === 200) {
                                        console.log("Notes Saved");
                                    }
                                    else {
                                        console.log("Notes not Saved");
                                    }
                                })
                                .catch((error) => {
                                    // errors (failed call)
                                    console.log("Notes Save Error!");
                                });
                            let btn = $('.tox-tbtn[aria-label=\'Save\']');
                            btn.addClass('saving');
                            setTimeout(function() {
                                btn.removeClass('saving');
                            }, 1000);
                        }
                    });
                },
                init_instance_callback: function(editor) {
                    // Tooltip click
                    tooltip.on('click', function() {
                        // Notepad toggle open
                        if(!$('#siteSubheaderTopicWidgetNotepadToggle').hasClass('open')) {
                            $('#siteSubheaderTopicWidgetNotepadToggle').addClass('open');
                            $('#notepad').addClass('open');
                        }

                        // Set a bookmark so we can return the user's cursor to the original location
                        const bookmark = editor.selection.getBookmark();

                        // Copy selected text to clipboard
                        navigator.clipboard.writeText(copiedText);
                        // tinyMCE.activeEditor.insertContent(copiedText); // eslint-disable-line no-undef

                        // Use editor.getBody() to find the end of all the content
                        editor.selection.setCursorLocation(editor.getBody(), editor.getBody().children.length);

                        // Insert clipboard text, with 2 empty lines at the start
                        editor.insertContent('<span>' + copiedText + '</span>');

                        // Move the selection back to the original bookmark
                        // editor.selection.moveToBookmark(bookmark);

                        // Hide tooltip
                        tooltip.hide();

                        // Reset selection current
                        selCurrent = '-';
                        if(window.getSelection) {
                            if(window.getSelection().empty) { // Chrome
                              window.getSelection().empty();
                            }
                            else if
                            (window.getSelection().removeAllRanges) { // Firefox
                              window.getSelection().removeAllRanges();
                            }
                        }
                        else if
                        (document.selection) { // IE?
                            document.selection.empty();
                        }
                    });
                }
            });

            // Initialise Tooltip 'popper' instance
            popperInstance = new Popper(virtualElement, tooltip, {
                placement: 'top',
                positionFixed: true,
                modifiers: {
                    offset: {
                        offset: '0,12'
                    }
                }
            });

            // If tooltip exists in the dom and clipboard is available in the browser
            if(navigator && navigator.clipboard && navigator.clipboard.writeText && tooltip.length) {
                // Tooltip mouse down (hide tooltip)
                window.addEventListener('mousedown', function(e) {
                    // selCurrent = '-';

                    // Are we clicking the tooltip itself?
                    if(!tooltip.get(0).contains(e.target)) {
                        // If parent elements contain the data attribute data-can-copy
                        if(!e.target.closest('[data-can-copy]') || e.target.parentNode.nodeName.toLowerCase() === 'button' || e.target.nodeName.toLowerCase() === 'button') {
                            // Hide tooltip
                            tooltip.removeClass('animate');
                            tooltip.hide();
                        }
                    }
                    else {
                        // console.log('clicking the tooltip');
                    }
                });

                // Tooltip mouse up (show tooltip)
                window.addEventListener('mouseup', function(e) {
                    // If text selection is empty, or if temp selection equals previous selection
                    if(sel.isCollapsed) {
                        // Hide tooltip
                        tooltip.hide();
                    }
                    else {
                        // console.log(sel.toString(), selCurrent);
                        // if((sel.toString() !== selCurrent)) {
                            // If clicked element is not the tooltip
                            // if(e.target.closest('.notepadBlock-tooltip') !== null) {
                                // If parent elements contain the data attribute data-can-copy
                                if(e.target.closest('[data-can-copy]') && e.target.parentNode.nodeName.toLowerCase() !== 'button' && e.target.nodeName.toLowerCase() !== 'button') {
                                    const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
                                    const posX = e.clientX - 110;
                                    const posY = e.clientY + 20 + scrollTop;

                                    // Show tooltip
                                    tooltip.removeClass('animate').addClass('animate');
                                    tooltip.show();
                                    updateTooltip(posX, posY);
                                }
                            // }
                        // }
                    }
                });

                // Update tooltip position on window resize
                $(window).on('resize', _.debounce(() => {
                    updateTooltip();
                }, 250));
            }
        }

        // Helper method - get bounding box
        function generateGetBoundingClientRect(width = 0, height = 0, top = 0, right = 0, bottom = 0, left = 0) {
            return () => ({
                width: width,
                height: height,
                top: top,
                right: right,
                bottom: bottom,
                left: left
            });
        }

        // Helper method - update tooltip position + get selection text
        function updateTooltip() {
            // sel = window.getSelection();
            if(!sel.isCollapsed) {
                let r = sel.getRangeAt(0).getBoundingClientRect();
                virtualElement.getBoundingClientRect = generateGetBoundingClientRect(r.width, r.height, r.top, r.right, r.bottom, r.left);
                popperInstance.update();
                copiedText = sel.toString();
                selCurrent = sel.toString();
            }
        }
	}
}
